import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export function useEligibilityData() {
  const location = useLocation();
  const storedData = JSON.parse(sessionStorage.getItem("eligibility_data") || "{}");
  const initialData = { ...storedData, ...(location.state?.data || {}) };
  const [userData, setUserData] = useState(initialData);

  useEffect(() => {
    if (userData?.userId && userData?.applicationId) return;

    const urlData = JSON.parse(sessionStorage.getItem("eligibility_url_data") || "{}");

    // Step 2: eligibility_url_data has userId + applicationId (institute-enrolled link)
    if (urlData?.userId && urlData?.applicationId) {
      const recovered = {
        userId: urlData.userId,
        applicationId: urlData.applicationId,
        mobile: urlData.mobile || "",
      };
      sessionStorage.setItem("eligibility_data", JSON.stringify(recovered));
      setUserData(recovered);
      return;
    }

    // Step 3: call API using mobile from eligibility_url_data
    const token = sessionStorage.getItem("eligibility_auth_token");
    const mobile = (urlData?.mobile || "").replace(/\D/g, "").slice(-10);
    if (!token || !mobile) return;

    let cancelled = false;
    fetch(
      `${process.env.REACT_APP_DASHBOARD_URL}/users/basic-info?searchField=${mobile}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
      .then((res) => res.json())
      .then((res) => {
        if (cancelled) return;
        const allApps: any[] = res?.data || [];
        const excluded = ["Disbursed", "Dropped", "Rejected", "On Hold"];
        const activeApps = allApps.filter((a) => !excluded.includes(a?.status));
        if (activeApps.length === 0) return;
        const latest = activeApps.reduce((prev: any, curr: any) => {
          const p = parseInt((prev?.applicationId || "").replace(/\D/g, ""), 10);
          const c = parseInt((curr?.applicationId || "").replace(/\D/g, ""), 10);
          return c > p ? curr : prev;
        }, activeApps[0]);
        if (!latest?.applicationId) return;
        const recovered = { userId: latest.userId, applicationId: latest.applicationId, mobile };
        sessionStorage.setItem("eligibility_data", JSON.stringify(recovered));
        setUserData(recovered);
      })
      .catch(() => {});

    return () => { cancelled = true; };
  }, []);

  return userData;
}
